import React, { useState } from "react";
import EditRegisterdetails from "./EditRegisterdetails";
import EditProfessionaldetails from "./EditProfessionaldetails";
import { Box } from "@mui/material";
import { Paper } from "@mui/material";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const ProfilepageMain = () => {
  const { token } = useAuth();
  console.log("tokenwa", token);
  const headers = {
    "x-access-token": token,
  };

  const [step, setStep] = useState(1);

  const handleBackClick = () => {
    setStep(step - 1);
  };
  const handleNextClick = () => {
    setStep(step + 1);
  };

  const handleSubmitFirstForm = async (formData) => {
    try {
      // Example update request
      const updateResponse = await axios.put(
        `${apiUrl}/CCE/api/v1/userEngine/updateUserProfile`,
        {
          ...formData,
        },
        { headers }
      );

      console.log("Update Response1:", updateResponse.data);
      if (updateResponse) {
        toast.success("Profile Details edited successfully!");
      }

      // Navigate to the "Thank You" page on successful agreement
    } catch (error) {
      console.error("Error updating user:", error.message);
      toast.error("failed to edit. Please try again.");
      // Handle the error appropriately
    }
    setStep(step + 1);
  };

  const handleSubmitSecondForm = async (formData) => {
    try {
      const token = sessionStorage.getItem("authToken");
      const headers = { "x-access-token": token };
      const { username, ...restFormData } = formData;
      const updateResponse = await axios.put(
        `${apiUrl}/CCE/api/v1/userEngine/updateUserProfile`,
        {
          ...restFormData,
          pointOfContact: username,
        },
        { headers }
      );

      console.log("Update Response1:", updateResponse.data);
      if (updateResponse) {
        sessionStorage.setItem("authToken", updateResponse.data.response.token);
        headers["x-access-token"] = updateResponse.data.response.token;
        toast.success("Professional Details edited successfully!");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to edit Professional Details.");
    }
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          marginTop: "-25px",
          height: "100%",
          padding: "10px",
        }}
      >
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          newestOnTop={true}
          closeOnClick
          pauseOnHover
          theme="colored"
          toastStyle={{ textAlign: "left" }} // Set text-align left
          fontSize="10px"
        />
        <div style={{ height: "7%", textAlign: "left" }}>
          <Paper sx={styles.dashboard_paper}>
            <h3>My Profile</h3>
          </Paper>
        </div>
        <Box sx={styles.formbox}>
          {step === 1 && (
            <EditRegisterdetails
              onSubmit={handleSubmitFirstForm}
              onClick={handleNextClick}
            />
          )}
          {step === 2 && (
            <EditProfessionaldetails
              onSubmit={handleSubmitSecondForm}
              onClick={handleBackClick}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default ProfilepageMain;

const styles = {
  formbox: {
    // border: "1px solid red",
    padding: "15px",
    borderRadius: "8px",
    width: "520px",
    height: "520px",
    margin: "auto",
  },
  textfield: {
    width: "400px",
  },
  btn: {
    width: "200px",
    height: "40px",
    marginTop: "1em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  btnprofessional: {
    margin: "10px",
    width: "100px",
    height: "40px",
    marginTop: "1em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
  },
};
